import React from 'react';
import SvgIcon from './SvgIcon';
import { SvgIconProps } from './types';

const WavingHandIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} width="140px" height="140px" viewBox="0 0 140 140">
        <g
            id="Tests"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <g
                id="1.Colleagues=No-Logo=Yes"
                transform="translate(-650.000000, -342.000000)"
            >
                <g
                    id="waving_hand_black_24dp"
                    transform="translate(650.000000, 342.000000)"
                >
                    <rect id="Rectangle" x="0" y="0" width="140" height="140" />
                    <path
                        d="M134.615385,98.5662349 C134.615385,117.843182 118.949225,133.509342 99.6722773,133.509342 L99.6722773,124.773565 C114.115428,124.773565 125.879608,113.009386 125.879608,98.5662349 L134.615385,98.5662349 Z M6.49065772,40.3277227 C6.49065772,21.0507752 22.1568175,5.38461538 41.4337651,5.38461538 L41.4337651,14.1203922 C26.990614,14.1203922 15.2264346,25.8845717 15.2264346,40.3277227 L6.49065772,40.3277227 Z M47.3158548,24.7198014 L20.5261392,51.5095171 C1.77333823,70.262318 1.77333823,100.72106 20.5261392,119.473861 C39.2789401,138.226662 69.737682,138.226662 88.4904829,119.473861 L129.665111,78.2992327 C132.518798,75.4455456 132.518798,70.8447031 129.665111,67.991016 C126.811424,65.1373289 122.210582,65.1373289 119.356894,67.991016 L93.615472,93.7324384 L89.4805376,89.5975041 L127.568525,51.5095171 C130.422212,48.65583 130.422212,44.0549875 127.568525,41.2013004 C124.714838,38.3476133 120.113995,38.3476133 117.260308,41.2013004 L83.3072553,75.154353 L79.172321,71.0194187 L119.298656,30.8930837 C122.152343,28.0393966 122.152343,23.4385542 119.298656,20.5848671 C116.444969,17.73118 111.844126,17.73118 108.990439,20.5848671 L68.8641043,60.711202 L64.845647,56.6345061 L96.7603517,24.7198014 C99.6140388,21.8661143 99.6140388,17.2652719 96.7603517,14.4115848 C93.9066646,11.5578977 89.3058221,11.5578977 86.452135,14.4115848 L42.0743887,58.7893311 C49.1794872,67.9327775 48.5388635,81.1529198 40.1525178,89.5392656 L36.0175834,85.4043312 C42.8314893,78.5904253 42.8314893,67.5251079 36.0175834,60.711202 L33.9792355,58.6728541 L57.68231,34.9697796 C60.5359971,32.1160925 60.5359971,27.51525 57.68231,24.6615629 C54.7703844,21.8661143 50.1695419,21.8661143 47.3158548,24.7198014 Z"
                        id="Shape"
                        fill="#ECECEC"
                        fillRule="nonzero"
                    />
                </g>
            </g>
        </g>
    </SvgIcon>
);

export default WavingHandIcon;
